if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Add event listener for form submission
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      // CUSTOM CODE: To avoid timing issue with renaming the button.
      connectedCallback() {
        // CUSTOM CODE: Check if the product has the "inquire" tag
        this.checkInquireTag();
      }

      // 🔹 NEW: Function for checking for the inquire tag
      checkInquireTag() {
        // Wait for the attribute to be available before proceeding
        const waitForTags = setInterval(() => {
          if (this.dataset.productTags) {
            clearInterval(waitForTags); // Stop checking once we find the tags
            console.log("Product tags found: ", this.dataset.productTags);

            const productTags = this.dataset.productTags
              ? this.dataset.productTags
                  .split(",")
                  .map((tag) => tag.trim().toLowerCase()) // Normalize case
              : [];

            console.log("Parsed tags: ", productTags);

            this.isInquireMode = productTags.includes("inquire"); // ✅ Lowercase check

            if (this.isInquireMode) {
              console.log("Inquire mode activated"); // Debugging check
              this.submitButton.textContent = "Inquire";
              this.submitButton.setAttribute("data-inquire", "true");

              // Ensure only the submit button redirects
              this.form.removeEventListener(
                "submit",
                this.onSubmitHandler.bind(this)
              );
              this.form.addEventListener("submit", (event) => {
                event.preventDefault();
                window.location.href = "/pages/contact";
              });
            }
          }
        }, 100); // Check every 100ms until data-product-tags appears
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // 🔹 NEW: If "Inquire" mode is active, redirect instead of adding to cart
        if (this.dataset.productTags.includes("inquire")) {
          window.location.href = "/pages/contact";
          return;
        }

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
